import axios from 'axios'

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
  fetchMarketingSourcesList ({ commit, rootGetters }, meta) {
    return axios
      .get(rootGetters['api/marketingSourcesList'])
      .then((res) => {
        return res.data.items
      })
  },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
